import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import Utils from "../../../../utils/utils";
import BusRouteController from "../../../../services/system/bus/bus-route-controller";
import moment from "moment/moment";

class ModalDetailPaymentRegisterBus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            busUserServiceRes: [],
            moneyRefund:  0,
            paidMoneyRefund:  0,
            name: '',
            dateCancel:  new Date(),
            price: 0,
            priceDiscount: 0,
            status: true,
            stateService: ""
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState(nextProps.item, ()=>{
                this.getDetailRouteBusRegister(nextProps.item?.id)
            })
        }
    }
    updatePaymentState() {
        let payment = parseFloat(this.state.payment.toString().replaceAll(",", ""))
        let paidMoneyRefund = parseFloat(this.state.paidMoneyRefund.toString().replaceAll(",", ""))
        let discount = parseFloat(this.state.discount.toString().replaceAll(",", ""))
        let moneyRefund = parseFloat(this.state.moneyRefund.toString().replaceAll(",", ""))
        let moneyPay = parseFloat(this.state.moneyPay.toString().replaceAll(",", ""))

        let payLoad = {
            "daDong": payment,
            "daHoanTra": paidMoneyRefund,
            "discount": discount,
            "hoanTra": moneyRefund,
            "id": this.state.id,
            "phaiDong": moneyPay,
            "reasonDiscount": this.state.reasonDiscount,
            "state": this.state.stateService
        }
        BusRouteController.updateBusUserPayment(payLoad, res => {
            if (res.success) {
                toast.success("Cập nhật thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    getDetailRouteBusRegister(busId) {
        BusRouteController.detailRegister(busId, res => {
            if (res.success){
                if (res.data.assistant1Res != null){
                    this.setState({
                        assistant1Id: res.data.assistant1Res["officerId"],
                        assistant1Name: res.data.assistant1Res["fullName"],
                        assistant1Username: res.data.assistant1Res["username"],
                    })
                }
                if (res.data.assistant2Res != null){
                    this.setState({
                        assistant2Id: res.data.assistant2Res["officerId"],
                        assistant2Name: res.data.assistant2Res["fullName"],
                        assistant2Username: res.data.assistant2Res["username"],
                    })
                }
                if (res.data.assistant3Res != null){
                    this.setState({
                        assistant3Id: res.data.assistant3Res["officerId"],
                        assistant3Name: res.data.assistant3Res["fullName"],
                        assistant3Username: res.data.assistant3Res["username"],
                    })
                }
                let userInfo = res.data.busUserServiceRes[res.data.id-1]
                this.setState({
                    busRouteId: res.data.id,
                    name: res.data.name,
                    driverName: res.data.driverName,
                    driverPhone: res.data.driverPhone,
                    busStopRes: res.data.busStopRes,
                    busUserServiceRes: res.data.busUserServiceRes,
                    paidMoneyTotal: res.data.paidMoneyTotal,
                    paidNumber: res.data.paidNumber,
                    remainMoneyTotal: res.data.remainMoneyTotal,
                    seatNumber: res.data.seatNumber,
                    seatNumberRegistered: res.data.seatNumberRegistered,
                    totalMoney: userInfo?.busTypeRes["price"]*userInfo.priceType,
                    payment:  userInfo?.payment,
                    discount:  userInfo?.discount,
                    moneyRefund:  userInfo?.moneyRefund?userInfo?.moneyRefund: 0,
                    paidMoneyRefund:  userInfo?.paidMoneyRefund?userInfo?.paidMoneyRefund: 0,
                    moneyPay:  userInfo?.busTypeRes["price"]*userInfo.priceType-userInfo?.payment-userInfo?.discount,
                }, ()=>{
                })
            }else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    getEndDayService(starDate, month){
        let end = new Date(starDate)
        let newDate = new Date(end.setMonth(end.getMonth()+parseInt(month)));
        return moment(newDate).format("DD-MM-YYYY")
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered modal-size-large">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Chi tiết thanh toán</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Tên tuyến bus</label>
                                    <label className="col-md-9 label-item pl-0"><b>{this.state.name}</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Tài xế xe bus</label>
                                    <label className="col-md-9 label-item pl-0"><b>{this.state.driverName}</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Số chỗ đã đăng ký</label>
                                    <label className="col-md-9 label-item pl-0"><b>{this.state.seatNumberRegistered}/{this.state.seatNumber}</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                    Thông tin đăng ký
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Tên học sinh</label>
                                    <label className="col-md-9 label-item pl-0"><b>{this.state.busUserServiceRes[this.state.busRouteId-1]?.fullName}</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-md-4 label-item pl-0">Loại dịch vụ xe bus</label>
                                    <label className="col-md-8 label-item pl-0"><b>{this.state.busUserServiceRes[this.state.busRouteId-1]?.busTypeRes.name}</b></label>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-md-4 label-item pl-0">Giá</label>
                                    <label className="col-md-8 label-item pl-0"><b>{Utils.formatMoney(this.state.busUserServiceRes[this.state.busRouteId-1]?.busTypeRes.price)}đ</b></label>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-md-4 label-item pl-0">Số tháng đăng ký xe bus</label>
                                    <label className="col-md-8 label-item pl-0"><b>{this.state.busUserServiceRes[this.state.busRouteId-1]?.priceType} tháng</b></label>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-md-4 label-item pl-0">Tổng tiền</label>
                                    <label className="col-md-8 label-item pl-0"><b>{Utils.formatMoney(this.state.totalMoney)} đ</b></label>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-md-4 label-item pl-0">Ngày bắt đầu dịch vụ</label>
                                    <label className="col-md-8 label-item pl-0"><b>{moment(this.state.busUserServiceRes[this.state.busRouteId-1]?.startDay).format("DD-MM-YYYY")}</b></label>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-md-4 label-item pl-0">Ngày kết thúc dịch vụ</label>
                                    <label className="col-md-8 label-item pl-0"><b>{this.getEndDayService(this.state.busUserServiceRes[this.state.busRouteId-1]?.startDay, this.state.busUserServiceRes[this.state.busRouteId-1]?.priceType)}</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Số tiền giảm trừ(Đăng ký dịch vụ mới)</label>
                                    <input
                                        placeholder="Nhập số tiền giảm trừ"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.discount)}
                                        onChange={(event) => {
                                            this.setState({
                                                discount: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Đã thanh toán</label>
                                    <input
                                        placeholder="Nhập số tiền giảm trừ"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.payment)}
                                        onChange={(event) => {
                                            this.setState({
                                                payment: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Số tiền phải đóng</label>
                                    <input
                                        placeholder="Nhập số tiền giảm trừ"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.moneyPay)}
                                        onChange={(event) => {
                                            this.setState({
                                                moneyPay: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Số tiền hoàn trả(Hủy dịch vụ)</label>
                                    <input
                                        placeholder="Nhập số tiền giảm trừ"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.moneyRefund)}
                                        onChange={(event) => {
                                            this.setState({
                                                moneyRefund: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Số đã hoàn trả(Hủy dịch vụ)</label>
                                    <input
                                        placeholder="Nhập số tiền giảm trừ"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.paidMoneyRefund)}
                                        onChange={(event) => {
                                            this.setState({
                                                paidMoneyRefund: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Chú thích</label>
                                    <input
                                        placeholder="Nhập nguyên nhân giảm giá, hoàn tiền,.."
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.reasonDiscount}
                                        onChange={(event) => {
                                            this.setState({
                                                reasonDiscount: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-md-3 label-item pl-0">Trạng thái thanh toán</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.stateService}
                                        onChange={(e) => {
                                            this.setState({
                                                stateService: e.target.value
                                            })
                                        }}
                                    >
                                        <option value="">Trạng thái</option>
                                        <option value="PAID">Đã thanh toán</option>
                                        <option value="NEW_REGISTER">Đăng ký mới</option>
                                        <option value="CANCEL">Đã hủy</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.updatePaymentState()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalDetailPaymentRegisterBus